const FPROM_TID_COOKIE = '_fprom_tid'
export const FPROM_TID_HEADER = 'Fprom-Tid'

function cookieValue(name) {
  if (!import.meta.client || typeof document === 'undefined') return ''
  const prefix = `${name}=`
  const row = document.cookie.split('; ').find((part) => part.startsWith(prefix))
  if (!row) return ''
  const raw = row.slice(prefix.length)
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

/** FirstPromoter click tracking id from `_fprom_tid` (set by fpr.js after `?fpr=`). */
export function getFpromTid() {
  return cookieValue(FPROM_TID_COOKIE)
}

export function getFpromTidHeaders() {
  const tid = getFpromTid()
  return tid ? { [FPROM_TID_HEADER]: tid } : {}
}
